<template>
  <div class="vs-prompt-form">
    <div class="vx-row mb-5">
      <div class="vx-col sm:w-1/4">
        <img :src="require('@/assets/images/' + form.integration.integrationType.toLowerCase() + '-logo.svg')" class="w-full" />
      </div>
      <div class="vx-col sm:w-3/4">
        <p>{{ form.integration.description }}</p>
      </div>
    </div>
    <div class="vx-row">
      <div class="vx-col md:w-1/2 mb-5">
        <vx-field
          type="input"
          class="w-full"
          label="Username"
          v-model="form.config.credentials.username"
          v-validate="'required'"
        />
      </div>
      <div class="vx-col md:w-1/2 mb-5">
        <vx-field
          type="password"
          class="w-full"
          label="Password"
          v-model="form.config.credentials.password"
          v-validate="'required'"
        />
      </div>
    </div>
    <div class="vx-row mb-2">
      <div class="vx-col">
        <p class="text-lg font-normal tracking wide text-black">Field Mappings</p>
      </div>
    </div>
    <div class="vx-row mb-2">
      <div class="vx-col w-11/12">
        <div class="vx-row w-full">
          <div class="vx-col w-1/3">
            <p class="text-base font-normal tracking wide text-black">Salesforce Entity</p>
          </div>
          <div class="vx-col w-1/3">
            <p class="text-base font-normal tracking wide text-black">Salesforce Field</p>
          </div>
          <div class="vx-col w-1/3">
            <p class="text-base font-normal tracking wide text-black">Value</p>
          </div>
        </div>
      </div>
    </div>
    <div class="vx-row mt-4" v-for="(item, index) in form.config.fields" :key="index">
      <div class="vx-col w-11/12">
        <div class="vx-row w-full">
          <div class="vx-col w-1/3">
            <vx-field
              type="select"
              autocomplete
              class="w-full"
              @blur="handleAutocompleteBlur"
              label=""
              :options="{
                value: 'value',
                text: 'title',
                items: entity || []
              }"
              v-model="item.configKey"
              v-validate="{ required: true }"
            />
          </div>
          <div class="vx-col w-1/3">
            <vx-field
              :key="index"
              type="input"
              class="w-full"
              label=""
              v-model="item.configField"
              v-validate="'required'"
              @input="validateField"
            />
          </div>
          <div class="vx-col w-1/3">
            <vx-field
              :key="index"
              type="input"
              class="w-full"
              label=""
              v-model="item.configValue"
              v-validate="'required'"
              @input="validateField"
            />
          </div>
        </div>
      </div>
      <div class="vx-col w-1/12 p-0">
        <div class="vx-row w-full">
          <vs-button type="border" size="medium" color="danger" icon-pack="feather" icon="icon icon-trash" @click="removeField(index)"></vs-button>
        </div>
      </div>
    </div>
    <div class="vx-row mt-5">
      <div class="vx-col w-full mr-auto">
        <vs-button color="primary" type="filled" @click="addField">Add Field</vs-button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SalesForceIntegrationForm',
  props: ['data'],
  data() {
    return {
      form: {
        integration: this.data.integration || {},
        config: {
          credentials: {},
          fields: [],
        }
      },
      entity: [
        {
          title: "Contact",
          value: "Contact"
        },
        {
          title: "Account",
          value: "Account"
        }
      ],
    }
  },
  methods: {
    addField() {
      this.form.config.fields.push({
        configKey: "Contact",
        configField: "",
        configValue: "contact.ContactType.name"
      });
    },
    removeField(index) {
      this.form.config.fields.splice(index, 1);
    },
    async submit(rest) {
      const validSubmit = this.form.config.fields.length > 0;
      if (rest && validSubmit) {
        const isUpdate = this.data.id;
        const dipsatchUrl = isUpdate ? 'updateIntegration' : 'createIntegration';

        const processedSalesForceConfig = this.processSalesForceConfig();
        const config = {
          "credentials": {
            "username": this.form.config.credentials.username,
            "password": this.form.config.credentials.password,
          },
          "fields": {
            ...processedSalesForceConfig,
          }
        }

        return await this.$store.dispatch(`visitManagement/${dipsatchUrl}`, {
          ...(isUpdate && {id: this.data.id}),
          integration: this.form.integration,
          config: JSON.stringify(config),
        })
          .then(result => result)
          .catch(err => {
            console.error(err);
            return false;
          });
      } else {
        this.$vs.notify({
          title: "Warning",
          text: "You need to add a field",
          color: "warning",
          fixed: false
        })
      }

      return validSubmit ? this.form : false;
    },
    populateSalesForceConfig() {
      const { config } = this.data;
      const salesForceConfig = this.configIsJson(config) || {};
      const { credentials, fields } = salesForceConfig;
      const configCredentials = {
        username: (credentials || {}).username || "",
        password: (credentials || {}).password || "",
      };
      this.form.config = {
        ...this.form.config,
        credentials: configCredentials,
      }
      this.populateSalesForceFields(fields);
    },
    populateSalesForceFields(fields) {
      for (const [key, value] of Object.entries(fields)) {
        this.populateEntities(key);
        for (const [fieldKey, fieldValue] of Object.entries(value)) {
          console.log(`${fieldKey}: ${fieldValue}`);
          this.form.config.fields.push({
            configKey: key,
            configField: fieldKey,
            configValue: fieldValue,
          });
        }
      }
    },
    populateEntities(key) {
      const inEntity = this.entity.filter(item => item.value === key);
      if (inEntity.length === 0) {
        this.entity.push({title: key, value: key})
      }
    },
    configIsJson(config) {
      try {
        config = JSON.parse(config);
      } catch (e) {
        console.error("configIsJson e >>> ", e);
        return false;
      }

      return config;
    },
    processSalesForceConfig() {
      let data = {}

      this.form.config.fields.forEach((field, index) => {
        if (index > 0) {
          const inDataKey = Object.keys(data).filter(key => key === field.configKey);
          if (inDataKey.length > 0) {
            return data[field.configKey] = {
              ...data[field.configKey],
              [field.configField]: field.configValue
            }
          }

          return data[field.configKey] = {
            [field.configField]: field.configValue,
          }
        }

        return data[field.configKey] = {
          [field.configField]: field.configValue,
        }
      });

      return data;
    },
    handleAutocompleteBlur(e) {
      const inputValue = e.target.value;
      const inEntity = this.entity.filter(item => item.value === inputValue);
      if (inEntity.length === 0 && inputValue.trim().length > 0) {
        this.entity.push({
          title: inputValue,
          value: inputValue
        })
      }
    },
    validateField () {
      this.$validator.validateAll();
    },
  },
  created() {
    this.data.id && this.populateSalesForceConfig();
  }
}
</script>
